import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../config/AuthContext";
import {
    Avatar,
    Button,
    FloatButton,
    Image,
    Progress,
    Space,
    Table,
    Tag,
    Tooltip,
    Typography
} from "antd";
import { BiPlus, BiRefresh } from "react-icons/bi";
import { IoOptions } from "react-icons/io5";
import AvaluacioColors from "../../../../styles/AvaluacioColors";
import JutgeColors from "../../../../styles/JutgeColors";
import { GetAules } from "../../../../dao/GetAules";
import ProjecteModal from "./ProjecteModal";
import { VscSettingsGear } from "react-icons/vsc";
import { FaArrowRight, FaEye } from "react-icons/fa";
import HomeColors from "../../../../styles/HomeColors";

const { Text, Paragraph } = Typography;

const Projectes = () => {
    const { isLoggedIn, userId, user, setBreadCrumb } = useContext(AuthContext);
    const { id_aula } = useParams();
    const [dades, setDades] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [selected, setSelected] = useState<any>();
    const navigate = useNavigate();

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [id_aula]);

    async function checkDades() {
        setLoading(true);
        const aules = await GetAules(userId);
        const aula = aules?.find((aul: any) => aul.id == id_aula);
        setDades(aula);
        setBreadCrumb(
            [
                { nom: 'Home', nav: '/home' },
                { nom: 'Aules', nav: '/home' },
                { nom: `Aula: ${aula.nom}`, nav: `/home/aules/${id_aula}` }
            ],
            true
        );
        setLoading(false);
    }

    const normalizeImg = (img?: string | null) => {
        if (!img) return "/images/default.png";
        if (img.startsWith("base64:")) img = img.split(":").pop()!;
        if (img.startsWith("/9j/")) return `data:image/jpeg;base64,${img}`;
        if (img.startsWith("iVB")) return `data:image/png;base64,${img}`;
        return `data:image/png;base64,${img}`;
    };

    function nuevo() {
        setSelected({ id: 0 });
        setModal(true);
    }

    function closeModal(refresh: boolean) {
        setModal(false);
        if (refresh) checkDades();
    }

    const columns = [
        {
            title: "Imatge",
            dataIndex: "img",
            key: "img",
            render: (img: string, record: any) => (
                <Space align="center">
                    <Avatar src={normalizeImg(img)} size={60} shape="square" />
                    <div>
                        <b>{`Activitat ${record.id}`}</b><br />
                        {record.nom || "Sense nom"}
                    </div>
                </Space>
            ),
        },
        {
            title: "Etiquetes",
            key: "etiquetes",
            render: (_: any, record: any) => (
                <Space size={[4, 4]} wrap>
                    {record.colab ? <Tag color="blue">Col·laboratiu</Tag> : <></>}
                    {record.ia ? <Tag color="purple">IA</Tag> : <></>}
                    {record.dudas ? <Tag color="orange">Dubtes</Tag> : <></>}
                    {record.copypaste ? <Tag color="red">Copypaste</Tag> : <></>}
                    {!record.colab && !record.ia && !record.dudas && !record.copypaste && (
                        <Tag color="default">Sense etiquetes</Tag>
                    )}
                </Space>
            ),
        },
        {
            title: "Accions",
            key: "actions",
            render: (_: any, record: any) => (
                <Space>
                    {(user.tipus === "0" || user.tipus === "1") && (
                        <Tooltip title="Editar">
                            <Button
                                size="small"
                                type="primary"
                                style={{
                                    backgroundColor: HomeColors.colors.color5,
                                    border: "none",
                                }}
                                icon={<VscSettingsGear />}
                                onClick={() => {
                                    setSelected(record);
                                    setModal(true);
                                }}
                            />
                        </Tooltip>
                    )}
                    <Tooltip title="Visualitzar">
                        <Button
                            size="small"
                            style={{
                                backgroundColor: HomeColors.colors.color3,
                                color: "white",
                            }}
                            icon={<FaArrowRight />}
                            onClick={() => navigate(`/home/aules/${id_aula}/projectes/${record.id}`)}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];

    return (
        <div className="p-4">
            <Table
                bordered
                loading={loading}
                pagination={{ pageSize: 6 }}
                rowKey="id"
                showHeader={false}
                columns={columns}
                dataSource={dades?.projectes || []}
            />

            {!loading && (
                <FloatButton.Group
                    trigger="click"
                    type="primary"
                    icon={<IoOptions />}
                    style={{ insetInlineStart: 97 }}
                >
                    {(user.tipus === "0" || user.tipus === "1") && (
                        <FloatButton
                            shape="circle"
                            onClick={() => nuevo()}
                            style={{
                                backgroundColor: AvaluacioColors.colors.color6,
                            }}
                            icon={<BiPlus />}
                        />
                    )}
                    <FloatButton
                        shape="circle"
                        onClick={() => checkDades()}
                        style={{
                            backgroundColor: AvaluacioColors.colors.color6,
                        }}
                        icon={<BiRefresh />}
                    />
                </FloatButton.Group>
            )}

            {modal && (
                <ProjecteModal
                    visible={modal}
                    onClose={(refresh: boolean) => closeModal(refresh)}
                    //alumnes={[]}
                    element={selected}
                //selectedIds={[]}
                />
            )}
        </div>
    );
};

export default Projectes;
